<template>
  <v-img
    :src="backgroundImg"
    class="page-vimg"
  >
    <v-container fill-height pa-0>
      <v-layout align-center>
        <v-flex xs12>
          <v-card
            class="text-xs-center margin-auto border-radius6 box-white-500-glow elevation-10 auth-box"
          >
            <v-layout align-center justify-center row fill-height wrap>
              <v-flex xs12 class="text-xs-center mt-3">
                <img src="/static/vuse-circle-white.svg" alt="Vuse" class="text-xs-center" height="100">
                <div class="headline">Sign in to your account</div>
                <v-form @submit.prevent="$v.$invalid ? null : submit()" ref="form">
                  <v-layout wrap row pa-4>
                    <v-flex xs12 pa-0>
                      <v-text-field
                        color="primary"
                        label="Email"
                        v-model="form.email"
                        required
                        :error-messages="fieldErrors('form.email')"
                        @blur="$v.form.email.$touch()"
                      ></v-text-field>

                      <v-text-field
                        color="primary"
                        label="Password"
                        v-model="form.password"
                        type="password"
                        required
                        :error-messages="fieldErrors('form.password')"
                        @blur="$v.form.password.$touch()"
                      ></v-text-field>
                      <div class="width-150x margin-horiz-center">
                        <v-checkbox
                          color="primary"
                          v-model="form.remeberme"
                          required
                        >
                          <div slot="label" @click.stop="() => {}">
                            Remember me
                          </div>
                        </v-checkbox>
                      </div>
                    </v-flex>

                    <v-flex xs12>
                      <v-layout row wrap text-xs-center>
                        <!-- Login form submit -->
                        <v-flex xs12 class="no-mrpd">
                          <v-btn
                            color="act"
                            type="submit"
                            :disabled="$v.$invalid"
                            block
                            :class="$v.$invalid ? '' : 'white--text'"
                          >Login</v-btn>
                        </v-flex>
                        <!-- Forgot password -->
                        <v-flex xs12>
                          <router-link :to="{ name: 'ForgotPassword' }" tag="div"
                            class="grey--text cursor-pointer"
                          >
                            <strong>Forgot Password ?</strong>
                          </router-link>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
                <div class="subheading">or Sign in with Google</div>
                <button class="social-button" @click="socialLoginGoogle" >
                    <img alt="Google logo"  width="50" src="../assets/googleicon.png" />
                </button>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      absolute
      top
      right
      :color="snackcolor"
    >
      <span>{{snacktext}}</span>
      <v-icon dark>check_circle</v-icon>
    </v-snackbar>
   <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-img>
</template>

<script>
import firebase from "firebase";

import { required, email, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";

const defaultForm = {
  email: "jlcumplido+4@gmail.com",
  password: "123456",
  rememberme: false
};
export default {
  mixins: [validationMixin],
  validations: {
    form: {
      email: { required, email },
      password: { required, minLength: minLength(6) }
    }
  },
  validationMessages: {
    form: {
      email: {
        required: "Please enter email",
        email: "Email must be valid"
      },
      password: {
        required: "Please enter password",
        minLength: "Password must be of 6 characters"
      }
    }
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      snackbar: false,
      snackcolor: "act",
      snacktext: "Sign in successful",
      dialog: false,
      backgroundImg: "/static/doc-images/HexesisMaterial01.png"
    };
  },
  methods: {
    submit() {
      this.dialog = true;
      const self = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(
          function(res) {
            self.dialog = false;
            if (res.user.emailVerified) {
              // alert(res.user.email)
              self.$store.commit("setUserEmail", res.user.email);
              self.$store.commit("setUserUid", res.user.uid);
              self.$store.commit("setUserLoggedIn", true);

              var docRef = self.$db.collection("users").doc(res.user.uid);
              docRef
                .get()
                .then(function(doc) {
                  if (doc.exists) {
                    docRef
                      .update({
                        lastloginDate: firebase.firestore.Timestamp.fromDate(
                          new Date()
                        )
                      })
                      .then(function() {
                        console.log("Document successfully updated!");
                      })
                      .catch(function(error) {
                        // The document probably doesn't exist.
                        console.error("Error updating document: ", error);
                      });
                    self.$store.commit("setUserData", doc.data());
                    self.$router.push({ name: "ProfilePage" });
                  } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                    var userData = {
                      userEmail: res.user.email,
                      creationDate: firebase.firestore.Timestamp.fromDate(
                        new Date()
                      ),
                      lastloginDate: firebase.firestore.Timestamp.fromDate(
                        new Date()
                      ),
                      credits: {
                        currentcredits: 0,
                        usedcredits: 0,
                        totalcredits: 0
                      },
                      subscriptions: {
                        currentsubscription: "",
                        subscriptionStartDate: null
                      },
                      operations: []
                    };
                    self.$db
                      .collection("users")
                      .doc(res.user.uid)
                      .set(userData)
                      .then(function() {
                        console.log("Document successfully written!");
                      });
                  }
                  self.$store.commit("setUserData", doc.data());
                  self.$router.push({ name: "ProfilePage" });
                })
                .catch(function(error) {
                  console.log("Error getting document:", error);
                });
            } else {
              self.snacktext =
                "Your email has not been verified. Please use the link in the email you have received";
              self.snackcolor = "red";
              self.snackbar = true;
            }
          },
          function(error) {
            self.dialog = false;
            self.snacktext = " " + error;
            self.snackcolor = "red";
            self.snackbar = true;
          }
        );
    },
    socialLoginGoogle() {
      this.dialog = true;
      const self = this;
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(
          function(res) {
            self.dialog = false;
            self.snackbar = true;
            // alert(res.user.email)
            self.$store.commit("setUserEmail", res.user.email);
            self.$store.commit("setUserUid", res.user.uid);
            self.$store.commit("setUserLoggedIn", true);
            var docRef = self.$db.collection("users").doc(res.user.uid);
            docRef
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  console.log("Document data:", doc.data());
                  docRef
                    .update({
                      lastloginDate: firebase.firestore.Timestamp.fromDate(
                        new Date()
                      )
                    })
                    .then(function() {
                      console.log("Document successfully updated!");
                    })
                    .catch(function(error) {
                      // The document probably doesn't exist.
                      console.error("Error updating document: ", error);
                    });
                  var userData = doc.data();
                  if (userData.credits == null) {
                    docRef.update({
                      credits: {
                        total: 0,
                        max: 0
                      }
                    });
                  }
                  self.$store.commit("setUserData", doc.data());
                  self.$store.commit("setUserData", doc.data());
                  self.$router.push({ name: "ProfilePage" });
                } else {
                  // doc.data() will be undefined in this case
                  console.log("No such document!");
                  var userData2 = {
                    userEmail: res.user.email,
                    credits: {
                      currentcredits: 0,
                      usedcredits: 0,
                      totalcredits: 0
                    },
                    subscriptions: {
                      currentsubscription: "",
                      subscriptionStartDate: null
                    },
                    operations: [],
                    creationDate: firebase.firestore.Timestamp.fromDate(
                      new Date()
                    ),
                    lastloginDate: firebase.firestore.Timestamp.fromDate(
                      new Date()
                    )
                  };
                  self.$db
                    .collection("users")
                    .doc(res.user.uid)
                    .set(userData2)
                    .then(function() {
                      console.log("Document successfully written!");
                    });
                }
              })
              .catch(function(error) {
                console.log("Error getting document:", error);
              });
          },
          function(error) {
            self.dialog = false;
            alert("Erroro " + error);
          }
        );
    },
    submit2() {
      this.snackbar = true;
      this.resetForm();
      this.$v.$reset();
      setTimeout(() => {
        this.$router.push({
          name: "dashboard/Dashboardv1"
        });
      }, 2000);
    },
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
    }
  }
};
</script>
